import actions from "./actions";

const initState = {
  loading: false,
  error: null,
  categoryDetails: []
};

export default function categoryReducer(state = initState, action) {
  switch (action.type) {
    case actions.GET_CATEGORY_DETAILS:
      return {
        ...state,
        loading: true,
        error: null
      };

    case actions.GET_CATEGORY_DETAILS_SUCCESS:
      return {
        ...state,
        loading: false,
        categoryDetails: action.payload || []   // ✅ payload is the array
      };

    case actions.GET_CATEGORY_DETAILS_FAILED:
      return {
        ...state,
        loading: false,
        error: action.payload
      };

    default:
      return state;
  }
}
